import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.getStudentList.loading;
export const getStudentListErrorMessage = (state: RootState) =>
  state.getStudentList.error;
export const getStudentListSuccessResponse = (state: RootState) =>
  state.getStudentList.studentListResponse;
